module.exports = __webpack_public_path__ + "static/img/tongbituitongzi.6d95226.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/tongbituitongzi.jpg
// module id = jAZE
// module chunks = 0